import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import StorePaymentMethods from './StorePaymentMethods.js';

const StorePaymentMethodsContainer = (_param)=>{
    var { logos , paymentMethods  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "logos",
        "paymentMethods"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.paymentMethods.title')
        })
    , [
        getLabel
    ]);
    const items = React.useMemo(()=>{
        return paymentMethods.map(({ code  })=>{
            var ref;
            const logo = logos === null || logos === void 0 ? void 0 : logos.find(({ key  })=>key === code
            );
            if (!logo) {
                return null;
            }
            return {
                name: logo.displayName,
                iconUrl: (ref = logo.logo) === null || ref === void 0 ? void 0 : ref.url
            };
        }).filter((item)=>item !== null
        );
    }, [
        paymentMethods,
        logos
    ]);
    return items.length > 0 ? /*#__PURE__*/ React.createElement(StorePaymentMethods, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    })) : null;
};

export { StorePaymentMethodsContainer as default };
//# sourceMappingURL=StorePaymentMethodsContainer.js.map
